import 'babel-polyfill'
import dottie from 'dottie'

import Vue from 'vue'
import App from './App'

import router from '@/router'
import { store } from '@/store'
import * as VueGoogleMaps from 'vue2-google-maps'

const MapsApiKey = 'AIzaSyAUpZ6Cm4DcUwFCUHxZhtVPzmbT996HmVw'

const checkAndAttachMapScript = function(callback) {
  // if (window.google) {
  //   // If you're using vue cli, then directly checking
  //   // 'google' obj will throw an error at the time of transpiling.
  //   callback()
  //   return true
  // }
  window.mapApiInitialized = callback
  const script = document.createElement('script')
  script.src = `https://maps.googleapis.com/maps/api/js?key=${MapsApiKey}&libraries=places,geometry&callback=mapApiInitialized`
  document.body.appendChild(script)
}

Vue.config.productionTip = false
Vue.use(VueGoogleMaps)
checkAndAttachMapScript(window.vueGoogleMapsInit)

const rootElement = dottie.get(process.env, 'VUE_APP_ROOT_ELEMENT', 'app')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount(`#${rootElement}`)
